import React from 'react';

export default function Coffee() {
	// 11
	let style = {
		st0: {
			fill:"#FFFFFF"
		},
		st16: {
			fill:"#E6E6E6"
		},
		st14: {
			fill:"#5E4C3E"
		},
		st31: {
			opacity:0.3
		}
	};
	return (
		<g>
			<path style={style.st0} d="M90.2728348,329.9684143c-16.4505234-5.8594055-34.1504707-5.8594055-50.6009903,0
				C36.7090263,331.0235291,35,333.8284912,35,336.9735413v23.5109558v23.5107117
				c0,3.1450806,1.8161507,5.9500122,4.778965,7.0053406l0,0c16.4505196,5.8592224,34.1245689,5.8592224,50.5750923,0l0,0
				C93.3168716,389.9452209,95,387.1402893,95,383.9952087v-23.5107117v-23.5109558
				C95,333.8284912,93.2356491,331.0235291,90.2728348,329.9684143z"/>
			<path style={style.st16} d="M42.5571785,336.2410889c14.6497879,4.5523071,30.3394432,4.5523071,44.9892387,0
				c0.9566803-0.2973022,0.9566803-1.6630859,0-1.9603577c-14.6497955-4.5523071-30.3394508-4.5523071-44.9892387,0
				C41.6004944,334.5780334,41.6004944,335.9438171,42.5571785,336.2410889z"/>
			<path style={style.st14} d="M46.5190544,337.3415222c12.1649818,3.0676575,24.9005013,3.0676575,37.0654869,0
				C71.4195557,334.2738647,58.6840363,334.2738647,46.5190544,337.3415222z"/>
			<path style={style.st0} d="M98.9023438,381.0688477h-6.9707031c-3.0371094,0-5.5-2.4624023-5.5-5.5s2.4628906-5.5,5.5-5.5h6.9707031
				c2.9902344,0,5.4228516-2.4326172,5.4228516-5.4223633v-7.4916992c0-2.9897461-2.4326172-5.4223633-5.4228516-5.4223633
				h-6.9707031c-3.0371094,0-5.5-2.4624023-5.5-5.5s2.4628906-5.5,5.5-5.5h6.9707031
				c9.0556641,0,16.4228516,7.3671875,16.4228516,16.4223633v7.4916992
				C115.3251953,373.7016602,107.9580078,381.0688477,98.9023438,381.0688477z"/>
			<g style={style.st31}>
				<path style={style.st16} d="M60.2207031,334.7641602c-0.4902344,0-0.9824219-0.1791992-1.3681641-0.5410156
					c-0.8056641-0.7553711-0.8466797-2.0209961-0.0908203-2.8266602c0.0302734-0.0327148,3.4003906-3.7177734,3.1435547-7.6953125
					c-0.125-1.949707-1.0947266-3.6547852-2.9648438-5.2128906c-2.7294922-2.2749023-4.2089844-4.9863281-4.3984375-8.0595703
					c-0.3515625-5.7119141,4.0332031-10.4580078,4.2197266-10.6572266c0.7548828-0.8061523,2.0214844-0.847168,2.8271484-0.0913086
					c0.8037109,0.7539062,0.8457031,2.0166016,0.0947266,2.8227539l0,0
					c-0.0341797,0.0366211-3.4042969,3.7216797-3.1474609,7.6992188c0.125,1.949707,1.0947266,3.6547852,2.9648438,5.2128906
					c2.7294922,2.2749023,4.2089844,4.9863281,4.3984375,8.0595703c0.3515625,5.7119141-4.0332031,10.4580078-4.2197266,10.6572266
					C61.2861328,334.5517578,60.7539062,334.7641602,60.2207031,334.7641602z"/>
			</g>
			<g style={style.st31}>
				<path style={style.st16} d="M67.6181641,312.125c-0.4902344,0-0.9824219-0.1791992-1.3681641-0.5410156
					c-0.8056641-0.7553711-0.8466797-2.0209961-0.0908203-2.8266602c0.0302734-0.0327148,3.4003906-3.7177734,3.1435547-7.6953125
					c-0.125-1.949707-1.0947266-3.6547852-2.9648438-5.2128906c-2.7294922-2.2744141-4.2089844-4.9858398-4.3984375-8.059082
					c-0.3515625-5.7119141,4.0332031-10.4584961,4.2197266-10.6577148c0.7548828-0.8066406,2.0214844-0.8466797,2.8271484-0.0913086
					c0.8046875,0.7543945,0.8466797,2.0170898,0.0947266,2.8232422c-0.0507812,0.0546875-3.4033203,3.7314453-3.1474609,7.6992188
					c0.125,1.9492188,1.0947266,3.6542969,2.9648438,5.2124023c2.7294922,2.2749023,4.2089844,4.9863281,4.3984375,8.0595703
					c0.3515625,5.7119141-4.0332031,10.4580078-4.2197266,10.6572266C68.6835938,311.9125977,68.1513672,312.125,67.6181641,312.125z
					"/>
			</g>
		</g>
	);
}



// WEBPACK FOOTER //
// ./src/components/Global/Goodies/Toy/Coffee.js